module.exports = __webpack_public_path__ + "static/media/notizblock_leer.301596e2.png";